<div id="notfound">
	<div class="notfound">
		<div class="notfound-404">
			<h1>Oops!</h1>
			<h2>{{ "404.message" | translate }}</h2>
		</div>
	</div>
</div>
